
<template>

<div>
    <div class="acount-profile-wrap savd-report-profile">
        <a class="profile_icon" href="https://business.spendid.io/dashboard">
            <img :src="`https://business.spendid.io/api/get-image/${userId}?ver=${Math.random()}`" width="50">
            <p class="profile_name">{{ userName }}</p>
        </a>
</div>
        <b-card no-body class="mb-3">
            
            <!-- <b-card-header>
                <h5>All Assessments</h5>
            </b-card-header> -->

            <b-card-body>
                <b-table bordereless striped :items="items" :fields="fields" small responsive="sm" class="mb-0">
                    <template #cell(date)="row" >  
                        {{dateFormat(row.item.date)}}
                    </template>
                    <template #cell(spendidScore)="row">  
                        {{parseFloat(row.item.spendidScore).toFixed(1)}}
                    </template>
                    <template #cell(predictedSavingAbility)="row" title="Download report">  
                        ${{(reverseFormatNumber(row.item.predictedSavingAbility,'en')/12).toFixed(0)}}
                    </template>
                    <template #cell(Action)="row" title="Download report">  
                        <a :href="`https://admin.spendid.io/download-request-detail-from-app/${row.item.downloadReport}`" download>
                            <b-button size="sm" class="btn btn-sm btn-success">
                            Download
                            </b-button>
                        </a>
                        <span class="d-block d-md-inline-block" tabindex="0" v-b-tooltip.bottom title="Coming Soon">
                            <b-button size="sm" disabled class="btn btn-sm btn-dark ml-2">
                                View
                            </b-button>
                        </span>
                        <span class="d-block d-md-inline-block" tabindex="0" v-b-tooltip.bottom title="Coming Soon">
                            <b-button size="sm" disabled class="btn btn-sm btn-danger ml-2">
                                Edit
                            </b-button>
                        </span>
                        <span class="d-block d-md-inline-block" >
                            <b-button size="sm" @click="onDelete(row.item.reportId)" class="btn btn-sm btn-danger ml-2">
                                Delete
                            </b-button>
                        </span>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
    </div>
</template>
  
<script>
    import moment from 'moment-timezone';
    import { new_api } from "../../auth_config.json"
    export default {
        components: {
            
        },
        mounted(){
            let headers = {
                    'Authorization': 'Bearer '+this.$cookies.get("userDetail").data.access_token
                };
            this.$http.get(`${new_api}/get-spendid-score`,{headers}).then((res) => {
                this.items = res.data.data
            })
        },        
        computed:{    
            userName(){
                return ((this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data) ? this.$cookies.get("userDetail").data.name : null) || this.data
            },
            userId(){
                return ((this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data) ? this.$cookies.get("userDetail").data.id : null) || this.data
            },
        },
        data() {
            return {
                fields:[
                    {
                        key:'date',
                        label: 'Date/Time Saved'
                    },
                    {
                        key:'spendidScore',
                        label: 'SPENDID Score'
                    },
                    {
                        key:'predictedSavingAbility',
                        label: 'Predicted Saving Ability (Monthly)'
                    },
                    {
                        key:'Action',
                        label: 'Action'
                    }
                ],
                // fields: ['date','reportName', 'spendidScore','predictedSavingAbility','downloadReport'],
            items: []
            }
        },
        methods:{
            reverseFormatNumber(val,locale){
                var group = new Intl.NumberFormat(locale).format(1111).replace(/1/g, '');
                var decimal = new Intl.NumberFormat(locale).format(1.1).replace(/1/g, '');
                var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
                reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
                return Number.isNaN(reversedVal)?0:reversedVal;
            },
            dateFormat(value){
                if (value) {
                    return moment.utc(String(value)).local().format('YYYY-MM-DD hh:mm A')
                }
            },
            onDelete(id){
                let headers = {
                    'Authorization': 'Bearer '+this.$cookies.get("userDetail").data.access_token
                };
                this.$http.delete(`${new_api}/delete-report/${id}`,{headers}).then((res) => {
                    // this.items= this.items.filter(item=> item.reportId!=id);
                    let headers = {
                    'Authorization': 'Bearer '+this.$cookies.get("userDetail").data.access_token
                    };
                    this.$http.get(`${new_api}/get-spendid-score`,{headers}).then((res) => {
                        this.items = res.data.data
                    })
                })
            }
        }
    }
</script>

<style scoped>
        
</style>